import React, { useEffect, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import ReactTooltip from 'react-tooltip';

import SelectProgram from '../components/SelectProgram';
import ProgramParticipants from './components/ProgramParticipants';
import { getBalance } from "@/services/program/getBalance";
import { isCascadingApprovalsEnabled, isBudgetEnabled, amountToUsFormat } from '@/shared/helpers';
import BudgetAndApprovalsSummary from './components/BudgetAndApprovalsSummary';

const ManageAndReward = ({ auth, program, organization, rootProgram }) => {
  const [balance, setBalance] = useState(0);
  const [approvalsRefreshKey, setApprovalsRefreshKey] = useState(0);

  const refreshApprovals = useCallback(() => {
    setApprovalsRefreshKey((key) => key + 1);
  }, []);

  const fetchBalance = useCallback(async () => {
    if (organization?.id && program?.id) {
      getBalance(organization.id, program.id)
        .then(setBalance)
        .catch(console.log);
    }
  }, [organization?.id, program?.id]);

  useEffect(() => {
    fetchBalance();
  }, [fetchBalance]);

  if (!organization?.id || !program?.id || !rootProgram?.id || !auth) {
    return (
      <div className="manager-home manager-manage-reward-page">
        <Container className="manager-home__shell manager-home__content">
          <div className="manager-card manager-card--loading">Loading…</div>
        </Container>
      </div>
    );
  }

  return (
    <div className="manager-home manager-manage-reward-page">
      <ReactTooltip place="top" type="dark" effect="solid" className="app-tooltip--elevated" />
      <Container className="manager-home__shell manager-home__content">
        <div className="manager-manage-reward">

          <section className="manager-card manager-manage-reward__hero">
            <div className="manager-manage-reward__hero-copy">
              <span className="manager-card__eyebrow">Participants</span>
              <h1 className="manager-manage-reward__title">Manage &amp; Reward</h1>
              <p className="manager-manage-reward__description">
                Search, reward, and manage participant accounts across your program.
              </p>
            </div>
            <div className="manager-manage-reward__hero-controls">
              <div
                className="manager-manage-reward__control"
                data-tip="Switch to a different program to manage"
              >
                <span className="manager-manage-reward__control-label">
                  Program
                </span>
                <div className="manager-manage-reward__control-body">
                  <SelectProgram showRefresh={false} label={null} />
                </div>
              </div>
              {Boolean(program.is_pay_in_advance) && (
                <div className="manager-manage-reward__balance">
                  <span className="manager-manage-reward__balance-label">Balance</span>
                  <strong className="manager-manage-reward__balance-value">
                    {amountToUsFormat(balance, true, "$")}
                  </strong>
                </div>
              )}
            </div>
          </section>

          {(isCascadingApprovalsEnabled(program.rootProgram) || isBudgetEnabled(program.rootProgram)) && (
            <section className="manager-card manager-manage-reward__budget">
              <BudgetAndApprovalsSummary
                organization={organization}
                program={program}
                rootProgram={program.rootProgram}
                approvalsRefreshKey={approvalsRefreshKey}
              />
            </section>
          )}

          <section className="manager-card manager-manage-reward__panel">
            <ProgramParticipants
              organization={organization}
              program={program}
              auth={auth}
              rootProgram={program.rootProgram}
              balance={balance}
              refreshBalance={fetchBalance}
              refreshApprovals={refreshApprovals}
            />
          </section>

        </div>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  program: state.program,
  organization: state.organization,
  rootProgram: state.rootProgram,
});

export default connect(mapStateToProps)(ManageAndReward);
